import { getOrders } from '../../services/api/order.api';
import { transformOrders } from '../../transforms/order';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';
import { GET_ORDER_LIST_REQUEST, GET_ORDER_LIST_SUCCESS, GET_ORDER_LIST_FAILURE } from '../types';
import i18n from '../../plugins/i18n';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformOrders([]),
		pagination: transformPagination({}),
	},

	mutations: {
		[GET_ORDER_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_ORDER_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			state.data = transformOrders(data);
			state.pagination = transformPagination(meta);
		},
		[GET_ORDER_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getOrders({ commit }, params = {}) {
			try {
				commit(GET_ORDER_LIST_REQUEST);

				const { data } = await getOrders({
					keyword: params.keyword,
					'filters[order_status]': params.status,
					'filters[channel_id]': params.channel,
					'filters[shipping_status]': params.shipment,
					'filters[is_reconciled]': params.reconciled_at,
					'filters[is_synced_with_thunder]': params.is_synced_with_thunder,
					page: params.page,
					per_page: 30,
				});
				commit(GET_ORDER_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_ORDER_LIST_FAILURE, error);
				// show toast
				this.dispatch('toast/showToast', {
					header: i18n.t('toast.error'),
					content: i18n.t('toast.unexpectedError'),
					type: 'danger',
				});
			}
		},
	},
};
